<template>
    <div class="projectListSection">
        <!-- 项目分类菜单 + 搜索 -->
        <div class="project-menu-box">
            <ul>
                <li @click="handelChageProject('高层建筑')"><strong>High-rise Buildings </strong><span>高层建筑</span></li>
                <li @click="handelChageProject('公共建筑')"><strong>Public Architecture </strong><span>公共建筑</span></li>
                <li @click="handelChageProject('酒店建筑')"><strong>Hotel Architecture </strong><span>酒店建筑</span></li>
                <li @click="handelChageProject('微型建筑')"><strong>Micro Architecture</strong><span>微型建筑</span></li>
            </ul>
            <div style="margin-top: -5px;" :class="['search-box', isMobile ? 'isIpadSearchBox' : '']">
                <el-input placeholder="Search 搜索" v-model="searchContent" class="input-with-select" ref="isFocus" @focus="handleFocus" @blur="handleBlur">
                    <el-button slot="prepend" icon="el-icon-search" @click="handleSearchContent"></el-button>
                </el-input>
            </div>
        </div>

        <!-- 主体内容 -->
        <section class="project-content-model">
            <el-row :gutter="10" v-if="ProjectList.length">
                <el-col class="product-list-model" :xs="24" :sm="12" :md="6" :lg="6" :xl="6" v-for="(item, index) in ProjectList" :key="index">
                    <div class="project-section" @click="handelDetail(item.proid,item.utype,item.mousefileurl,item.pwdstr,item.tempwdstr,item.uflag,index)" :ref="index === 0 ? 'projectCol' : null">
                        <div class="project-img" :style="{height : projectColHeight + 'px'}" v-if="item.utype != 3 && item.utype != 4">
                            <img class="main-image" :src="item.fileurl" @contextmenu.prevent>
                            <img class="secondary-image" :src="item.mousefileurl" @contextmenu.prevent>

                            <!-- 普通访问 直接展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>

                            <!-- 受邀访问 点击展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                        </div>
                        <div class="project-img-move" :style="{height : projectColHeight + 'px'}" v-else>
                            <img class="main-image" :src="item.fileurl" @contextmenu.prevent>
                            <img class="videoIcomPlay" src="../assets/images/playIcon.png"/>

                            <!-- 普通访问 直接展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>

                            <!-- 受邀访问 点击展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText" @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                        </div>
                        <div class="project-model-box">
                            <div class="project-name-box">
                                <p>{{ item.introstr }}</p>
                                <h5 :title="item.proname" v-if="item.utype != 3 && item.utype != 4">{{ item.proname }}</h5>
                                <h5 :title="item.proname" v-else style="font-family: Arial;font-size: 1.5rem;font-weight: 500;">{{ item.proname }}</h5>
                            </div>
                            <div :class="['project-time-box', isMobile ? 'mobileProjectTime' : '']">
                                <div :class="[isMobile ? 'mobileTime' : '']" style="margin-bottom: 5px;text-align: right;">{{ item.projectctime }}</div>
                                <div style="display: flex;align-items: center;">
                                    <span style="display: flex;align-items: center;font-weight: 500;width: 100%;justify-content: flex-start;"><img :class="[isMobile ? 'yanMobileSize' : 'yanSize']" src="../assets/images/yan.png"/> <span :class="[isMobile ? 'mobileView' : '']">{{ item.bornum }}</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div v-if="isSearchResult == 1">
                <el-empty description="暂无项目内容" :image-size="150" v-if="ProjectList.length <= 0"></el-empty>
            </div>
            <div v-if="isSearchResult == 2">
                <el-empty description=" No related content available 未找到匹配信息" :image-size="150" v-if="ProjectList.length <= 0">
                    <el-button type="primary" size="small" style="background-color: #E0E0E0;color: #333;border: 1px solid #E0E0E0;font-family: 'ahronbd';font-size: 16px;" @click="handleResetContent">Reset Search 重置搜索</el-button>
                </el-empty>
            </div>
        </section>

        <!-- 视频播放 -->
        <div class="Image-Preview-full-box" v-if="isFullVideo" ref="fullscreenElement">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" @click="handelVideoviewClose">
                <img src="../assets/images/close-white.png" />
            </div>
            <video ref="videoFullPlayer" @play="handlePlay" @click="hanldeFullPalayVideo" controls :src="FullVideoUrl" controlslist="nodownload nofullscreen"></video>

            <div style="position: absolute;width: 80px;left: 50%;top: 50%;transform: translate(-50%, -50%);"><img style="width: 100%;" src='../assets/images/playIcon.png' v-if="!isvideoFullPlayer" @click="hanldeFullPalayVideo"></div>
        </div>
    </div>
</template>

<script>

import screenfull from 'screenfull'

import {getItemList,getProjectClassificatList,setPageViewInfo,setSearchContentList} from '@/api/axios-api'

export default {
    name: 'ProjectListSection',
    // 该组件为「项目列表」可复用区块：About 页向下浏览时按需渲染，也供 ProjectList 页复用
    props: {
        // 初始分类：1 高层建筑 / 2 公共建筑 / 3 酒店与地产 / 4 建筑与研究；不传则加载全部项目
        initType: {
            type: [String, Number],
            default: ''
        }
    },
    data () {
        return {
            isFullVideo: false,
            ProjectList: [],
            projectColHeight: 0,
            FullVideoUrl: '',
            password: '',
            passwordStateIndex: '',
            utypeState: '',
            proid: '',
            mousefileurl: '',
            pwdstr: '',
            tempwdstr: '',
            placeholderText: 'Decode 解码',
            isSpanceEnter: false,
            OldDindex: '',
            isPC: false,
            isMobile: false,
            systemLanguage: '', // 获取系统语言
            searchContent: '',
            isSearchResult: 1,
            ipuserflag: false, // 判断游客有没有登录
            isVipShow: false,
            isvideoFullPlayer: true,
            spanceIndex: 0,
            isLocked: true
        }
    },
    created () {
        
        // 查看有没有登录
        if (sessionStorage.getItem('isVisited') != null) {
            this.ipuserflag = JSON.parse(sessionStorage.getItem('isVisited'))
        } else {
            this.ipuserflag = false
        }

        this.systemLanguage = navigator.language || navigator.userLanguage
    },
    mounted () {
        const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if (userAgent) {
            this.isMobile = true
        } else {
            this.isPC = true
        }

        // 初始分类
        if (this.initType == 1) {
            this.getProjectClassificatListFun('高层建筑')
        } else if (this.initType == 2) {
            this.getProjectClassificatListFun('公共建筑')
        } else if (this.initType == 3) {
            this.getProjectClassificatListFun('酒店与地产')
        } else if (this.initType == 4) {
            this.getProjectClassificatListFun('建筑与研究')
        } else {
        
            // alert(sessionStorage.getItem('isScrollLock'))
            // if (sessionStorage.getItem('isScrollLock') != '1') {
                // alert('111')
                this.getItemListFun()
            // } else {
            //     alert('111')
            //     this.ProjectList = sessionStorage.getItem('ProjectListData')
            // }
            
        }

        // 注意：这里使用 addEventListener，避免覆盖宿主页面（About）自身的 window.onresize 逻辑
        window.addEventListener('resize', this.handleResize)

        
        window.addEventListener('wheel', this.unlockScroll);
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('keyup', this.setHandleSearchEnter)
        window.removeEventListener('keyup', this.JumpDetails)
        window.removeEventListener('scroll', this.handelScrollTop) // 项目菜单固定
        window.removeEventListener('wheel', this.unlockScroll);
    },
    
    methods: {

        unlockScroll () {
            // alert(this.isLocked)
             if (!this.isLocked) return;
             this.isLocked = false;
             window.addEventListener('scroll', this.handelScrollTop) // 项目菜单固定
        },

        handelScrollTop () {
            let scrollProjectTop = window.pageYOffset || document.documentElement.scrollTop
            // console.log(scrollProjectTop)
            // alert('111')
            // if (sessionStorage.getItem('isScrollLock') == 1) {
                sessionStorage.setItem('aboutPageScroll', scrollProjectTop)
            // } else {
                // sessionStorage.setItem('aboutPageScroll', scrollProjectTop)
            // }
            
        },

        handleResize () {
            this.$nextTick(() => {
                this.setProjectColHeight()
            })
        },

        // 卡片高度 = 卡片宽度 / 2（原逻辑），加空值保护，避免无数据时报错
        setProjectColHeight () {
            if (this.$refs.projectCol && this.$refs.projectCol[0]) {
                this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
            }
        },

        handleFocus () {
            window.addEventListener('keyup', this.setHandleSearchEnter)
        },
        handleBlur () {
            window.removeEventListener('keyup', this.setHandleSearchEnter)
        },

        handlePlay () {
            if (!this.isvideoFullPlayer) {
                screenfull.toggle(this.$refs.fullscreenElement)
            }
            this.isvideoFullPlayer = true
        },

        hanldeFullPalayVideo () {
            if (this.$refs.videoFullPlayer.paused) { // 检查视频是否暂停，如果是则播放
                this.$refs.videoFullPlayer.play()
                this.isvideoFullPlayer = true
                screenfull.toggle(this.$refs.fullscreenElement)
            } else { // 如果视频正在播放，则暂停（可选）
                this.$refs.videoFullPlayer.pause()
                this.isvideoFullPlayer = false
            }
        },

        // 搜索功能
        handleSearchContent () {
            this.isSearchResult = 2
            const parseInfo = {}
            parseInfo.pname = this.searchContent
            setSearchContentList(parseInfo).then(res => {
                if (res.code == 0) {
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                    }
                    this.ProjectList = res.map.list
                    this.passwordStateIndex = ''
                    this.$nextTick(() => {
                        this.setProjectColHeight()
                    })
                }
            })
        },

        // 按回车键搜索
        setHandleSearchEnter (event) {
            this.isSearchResult = 2
            if (event.key === 'Enter' || event.keyCode === 13) {
                const parseInfo = {}
                parseInfo.pname = this.searchContent
                setSearchContentList(parseInfo).then(res => {
                    if (res.code == 0) {
                        for (let i = 0; i < res.map.list.length; i++) {
                            if (res.map.list[i].uflag == 2) {
                                res.map.list[i].password = ''
                                res.map.list[i].placeholderText = 'Decode 解码'
                            }
                        }
                        this.ProjectList = res.map.list
                        this.$nextTick(() => {
                            this.setProjectColHeight()
                        })
                    }
                })
            }
        },

        handleResetContent () {
            this.searchContent = ''
            const parseInfo = {}
            parseInfo.pname = this.searchContent
            setSearchContentList(parseInfo).then(res => {
                if (res.code == 0) {
                    this.$refs.isFocus.focus()
                    this.ProjectList = res.map.list
                    this.$nextTick(() => {
                        this.setProjectColHeight()
                    })
                }
            })
        },

        // 切换项目导航内容
        handelChageProject (tvalue) {
            this.getProjectClassificatListFun(tvalue)
            // 只回滚到本区块顶部，避免把整个 About 页面拉回最上方
            this.$nextTick(() => {
                const rect = this.$el.getBoundingClientRect()
                const scrollTop = (window.pageYOffset || document.documentElement.scrollTop) + rect.top - 100
                window.scrollTo({
                    top: scrollTop > 0 ? scrollTop : 0,
                    behavior: 'smooth'
                })
            })
        },

        getProjectClassificatListFun (tvalue) {
            const parseInfo = {}
            parseInfo.tvalue = tvalue
            getProjectClassificatList(parseInfo).then(res => {
                if (res.code == 0) {
                    this.ProjectList = []
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                    }
                    this.ProjectList = res.map.list
                    this.$nextTick(() => {
                        this.setProjectColHeight()
                    })
                }
            })
        },

        handelDetail (proid, utype, mousefileurl, pwdstr, tempwdstr, uflag, index) {
            this.password = ''
            this.isSpanceEnter = false

            sessionStorage.setItem('oldProjectScrollTop', window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)

            sessionStorage.setItem('isScrollLock', 1)

            if (this.OldDindex != index) {
                this.placeholderText = 'Decode 解码'
            }
            this.OldDindex = index

            if (uflag == 1) {
                // 直接访问
                const parseInfo = {}
                parseInfo.proid = proid
                setPageViewInfo(parseInfo).then(res => {
                    console.log(res)
                })
                if (utype == 3 || utype == 4) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.$refs.videoFullPlayer.play()
                        }, 2000) // 2秒后自动播放视频
                    })

                    this.FullVideoUrl = mousefileurl
                    this.isFullVideo = true
                    document.body.style.overflow = 'hidden'

                    screenfull.toggle(this.$refs.fullscreenElement)
                    this.isvideoFullPlayer = true

                    if (screenfull.enabled) {
                        screenfull.on('change', () => {
                            if (!screenfull.isFullscreen) {
                                this.isvideoFullPlayer = false
                                this.$refs.videoFullPlayer.pause()
                            }
                        })
                    } else {
                        alert('全屏API不被支持')
                    }
                } else {
                    this.$router.push({
                        path: '/projectDetail',
                        query: { proid: proid }
                    })
                }
            } else if (uflag == 2) {
                this.passwordStateIndex = index
                this.proid = proid
                this.pwdstr = pwdstr
                this.tempwdstr = tempwdstr
                this.mousefileurl = mousefileurl
                this.utypeState = utype
            }
        },

        JumpDetails (event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                if (this.password == this.pwdstr || this.password == this.tempwdstr) {
                    this.setJumpDetailsFun(this.proid, this.mousefileurl, this.password)
                    this.password = ''
                    this.placeholderText = 'Decode 解码'
                } else {
                    this.ProjectList[this.spanceIndex].password = ''
                    this.ProjectList[this.spanceIndex].placeholderText = '密码错误'
                    this.isSpanceEnter = false

                    setTimeout(() => {
                        this.ProjectList[this.spanceIndex].placeholderText = 'Decode 解码'
                    }, 1500)
                }
            }
        },

        setJumpDetailsFun (proid, mousefileurl, password) {
            const parseInfo = {}
            parseInfo.proid = proid
            setPageViewInfo(parseInfo).then(res => {
                console.log(res)
            })

            if (this.utypeState == 3 || this.utypeState == 4) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.videoFullPlayer.play()
                    }, 2000) // 2秒后自动播放视频
                })
                this.FullVideoUrl = mousefileurl
                this.isFullVideo = true
                document.body.style.overflow = 'hidden'
                screenfull.toggle(this.$refs.fullscreenElement)
                this.isvideoFullPlayer = true

                if (screenfull.enabled) {
                    screenfull.on('change', () => {
                        if (!screenfull.isFullscreen) {
                            this.isvideoFullPlayer = false
                            this.$refs.videoFullPlayer.pause()
                        }
                    })
                } else {
                    alert('全屏API不被支持')
                }
            } else {
                this.$router.push({
                    path: '/projectDetail',
                    query: { proid: proid, pwdstr: password }
                })
            }
        },

        // 监听 input 输入
        handlePasswordInpt (event, index, pwdstr, tempwdstr) {
            this.password = event
            this.spanceIndex = index

            this.pwdstr = pwdstr
            this.tempwdstr = tempwdstr

            if (this.password === '') {
                this.isSpanceEnter = false
                window.removeEventListener('keyup', this.JumpDetails) // 消除回车键功能
            } else {
                this.isSpanceEnter = true
                window.addEventListener('keyup', this.JumpDetails) // 按回车键监听输入密码跳转详情页
            }
        },

        handelVideoviewClose () {
            document.body.style.overflow = 'auto'
            window.scrollTo({
                top: sessionStorage.getItem('oldProjectScrollTop'),
                behavior: 'smooth'
            })
            this.isvideoFullPlayer = true
            this.isFullVideo = false
            this.FullVideoUrl = ''

            document.exitFullscreen()
        },

        toggleFullScreen () {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
                })
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                }
            }
        },

        getItemListFun () {
            const parseInfo = {}
            parseInfo.utype = 1 // 1项目，2新闻
            getItemList(parseInfo).then(res => {
                if (res.code == 0) {
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                    }
                    this.ProjectList = res.map.list
                    this.$nextTick(() => {
                        this.setProjectColHeight()
                        if (sessionStorage.getItem('aboutPageScroll') != undefined) {
                            setTimeout(() => {
                                 window.scrollTo({ top: sessionStorage.getItem('aboutPageScroll')})
                            },100)
                           
                        } else {
                            window.scrollTo({ top: 0})
                        }
                        
                    })
            
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.projectListSection .project-content-model {
    padding: 40px 30px 2px 30px;
}
.projectListSection .project-content-model .product-list-model {
    margin-bottom: 35px;
}
.projectListSection .project-content-model .project-section {
  font-family: "SourceHanSans";
  cursor: pointer;
}
.projectListSection .project-img {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}

.projectListSection .project-img .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.projectListSection .project-img-move {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}
.projectListSection .project-img-move .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}
.projectListSection .videoIcomPlay {
  position: absolute;
  width: 55px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.projectListSection .project-img .secondary-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  opacity: 0; /* 默认隐藏 */
}
.projectListSection .project-img:hover .main-image {
  opacity: 0;
}
.projectListSection .project-img:hover .secondary-image {
  opacity: 1;
}
.projectListSection .project-content-model .project-section h5 {
  font-size: 1.125rem;
  font-weight: 700;
  font-family: "SourceHanSans";
  white-space: break-spaces;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.projectListSection .project-content-model .project-section p {
  font-size: 1.25rem;
  padding: 12px 0 0px 0;
  font-family: "ahronbd";
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.projectListSection .project-model-box {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
}
.projectListSection .project-name-box {
  width: 70%;
}
.projectListSection .project-time-box {
  font-size: 0.875rem;
  font-family: Arial;
  padding: 1rem 0 0 0;
  font-weight: 700;
}

// 项目菜单：嵌入场景使用 sticky 吸顶（原页面为 fixed，会遮挡宿主页面内容）
.projectListSection .project-menu-box {
  border-bottom: 1px solid #262626;
  color: #262626;
  background: #fff;
  z-index: 8;
  width: calc(100% - 60px);
  padding: 0px 0 0 0;
  margin: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 6.125rem;
}

.projectListSection .project-menu-box ul {
    display: flex;
    padding: 0px 20px 0px 0px;
    overflow: hidden;
    overflow-x: scroll;
}
.projectListSection .project-menu-box ul::-webkit-scrollbar {
  height: 0px;
}
.projectListSection .project-menu-box ul li {
  float: left;
  margin-right: 55px;
  padding: 10px 0 15px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.projectListSection .project-menu-box ul li strong {
  font-size: 1.25rem;
  font-family: "ahronbd";
  font-weight: 500;
}
.projectListSection .project-menu-box ul li span {
  font-family: 'SourceHanSansBOLD';
  font-size: 1.125rem;
  padding-left: 4px;
}

.projectListSection .Image-Preview-full-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    z-index: 999;
}
.projectListSection .Image-Preview-full-box video {
    width: 100%;
    height: 100%;
}
.projectListSection::v-deep .passwordInpt {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 150px;
  margin-left: -75px;
  margin-top: -16px;
  background-color: #000;
  border-radius: 16px;
}
.projectListSection::v-deep .passwordInpt .el-input__inner {
  background-color: #000;
  border: 1px solid #000;
  border-radius: 17px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-family: "SourceHanSans";
}
.projectListSection::v-deep .passwordInptSpance .el-input__inner{
    letter-spacing: 5px;
    font-size: 25px;
    font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}
.projectListSection::v-deep .passwordInptMobileSpance .el-input__inner{
    letter-spacing: 5px;
    font-size: 10px;
    height: 32px;
    line-height: 32px;
}

.projectListSection::v-deep .search-box {
  position: relative;
  width: 19rem;
  height: 2.5rem;
}
.projectListSection::v-deep .search-box .el-input-group {
  height: 100%;
}

.projectListSection::v-deep .search-box .el-input__inner {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  border-left: 1px solid #F2F2F2;
  background-color: #F2F2F2;
  font-family: "SourceHanSansBOLD";
  font-size: 1.125rem;
  height: 100%;
  margin-left: -2px;
  padding-left: 1px;
}
.projectListSection::v-deep .search-box .el-input.is-active .el-input__inner,
.projectListSection::v-deep .search-box .el-input__inner:focus {
  border-top: 1px solid #DCDFE6;
  border-bottom: 1px solid #DCDFE6;
  border-right: 1px solid #DCDFE6;
  outline: 0;
}
.projectListSection::v-deep .search-box .el-input-group__append,
.projectListSection::v-deep .search-box .el-input-group__prepend {
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  background-color: #F2F2F2;
  padding-right: 10px;
}

.projectListSection::v-deep .search-box .el-icon-search:before {
  color: #000;
  font-size: 1.5625rem;
}
.projectListSection::v-deep .el-icon-search {
  margin-top: 3px;
  margin-left: -9px;
}

.projectListSection .mobileProjectTime {
  padding: 13px 0 0 0;
}
.projectListSection .project-time-box .yanSize {
  width: 19px;
  margin-right: 5px;
}
.projectListSection .project-time-box .yanMobileSize {
  width: 14px;
  margin-right: 5px;
}
.projectListSection .project-time-box .mobileTime {
  font-size: 11px;
}
.projectListSection .project-time-box .mobileView {
  font-size: 12px;
}

.projectListSection .vip-model {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
  background: rgba(0,0,0,0.5);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s ease;
}
.projectListSection .vipshowmodel {
  transform: translateY(0);
}

@media only screen and (min-width: 2048px) {
  .projectListSection .project-menu-box ul li strong {
    font-size: 1.3rem;
  }
  .projectListSection .project-menu-box ul li span {
    font-size: 1.1rem;
  }
}

@media only screen and (min-width: 2560px) {
  .projectListSection .project-menu-box {
    padding: 80px 0 0 0;
  }
  .projectListSection .project-menu-box ul li strong {
    font-size: 1.35rem;
  }
  .projectListSection .project-menu-box ul li span {
    font-size: 1.12rem;
  }
}

@media (min-width: 1536px) and (max-width: 1708px) {
  .projectListSection .project-menu-box ul li strong {
    font-size: 1.25rem;
  }
  .projectListSection .project-menu-box ul li span {
    font-size: 1.08rem;
  }
}

@media (min-width: 1463px) and (max-width: 1536px) {
  .projectListSection .project-menu-box ul li strong {
    font-size: 1.2rem;
  }
  .projectListSection .project-menu-box ul li span {
    font-size: 1.0625rem;
  }
}

@media (min-width: 1360px) and (max-width: 1463px) {
  .projectListSection .project-menu-box ul li {
    margin-right: 52px;
  }
  .projectListSection .project-menu-box ul li strong {
    font-size: 1.2rem;
  }
  .projectListSection .project-menu-box ul li span {
    font-size: 1.0625rem;
  }
}

@media only screen and (max-width: 1280px) {
    .projectListSection .project-menu-box {
        padding: 40px 0 0 0;
        top: 0;
    }
    .projectListSection .project-menu-box ul li {
        margin-right: 25px;
    }
    .projectListSection .project-menu-box ul li span {
        padding-left: 5px;
        font-size: 1rem;
    }
    .projectListSection .project-menu-box ul li strong {
        font-size: 1.3rem;
    }
}

// ipad样式
.projectListSection .isIpadSearchBox {
  position: relative;
  width: 20.94rem;
  height: 3rem;
}
.projectListSection::v-deep .isIpadSearchBox .el-input__inner {
  height: 3rem;
  line-height: 3rem;
}
</style>
